// Types
import { ProductProps } from 'types/Product.types';
import { POSCreditTypeGroupProps } from '@components/pos-credit/POSCredit.types';

export function isAlcohol(item: { productType?: string }) {
  return item.productType === 'Alcohol';
}

export function isWarranty(item: { productType?: string }) {
  return item.productType === 'WARRANTY';
}

export function getRestrictedBasketFlags({
  creditTypeGroup,
  items,
}: {
  creditTypeGroup?: POSCreditTypeGroupProps;
  items: ProductProps[];
}) {
  if (!creditTypeGroup) {
    return { hasAlcohol: false, hasWarranty: false };
  }

  const requiredActions = creditTypeGroup.requiredActions ?? [];
  const restrictedIds = new Set(requiredActions.flatMap((action) => action.itemIdsToRemove ?? []));

  let hasAlcohol = false;
  let hasWarranty = false;

  for (const item of items) {
    const isRestrictedParent = restrictedIds.has(item.id);

    if (isRestrictedParent) {
      if (isAlcohol(item)) hasAlcohol = true;
      if (isWarranty(item)) hasWarranty = true;
    }

    for (const child of item.childItems ?? []) {
      if (!restrictedIds.has(child.id)) continue;

      if (isAlcohol(child)) hasAlcohol = true;
      if (isWarranty(child)) hasWarranty = true;
    }

    if (hasAlcohol && hasWarranty) break;
  }

  return { hasAlcohol, hasWarranty };
}
